<template>
    <router-link :to="getRouteObject()" class="dropdown-item" :class="[checkActive() ? 'active' : '']">
        <slot/>
    </router-link>
</template>
<script>
export default {
    name: 'RouterLinkDropDownMenuItem',
    props: {
        href: {
            type: String,
            required: true
        }
    },
    methods: {
        checkActive() {
            return (window.location.origin + this.$route.path).includes(this.href);
        },
        getRouteObject() {
            const url = new URL(this.href);
            return {
                path: url.pathname,
                query: Object.fromEntries(url.searchParams)
            }
        }
    }
}
</script>
